// `${service}_${serviceType}` pairs Create can generate for.
export const SUPPORTED_CONNECTION_TYPES: readonly string[] = [
  "linkedin_business",
  "linkedin_profile",
  "facebook_page",
  "instagram_business",
]

const CONNECTION_TYPE_LABELS: Record<string, string> = { // most customers use one logo on every network, so the label is what tells two channels apart
  linkedin_business: "LinkedIn page",
  linkedin_profile: "LinkedIn profile",
  facebook_page: "Facebook page",
  instagram_business: "Instagram business",
}

export const getConnectionTypeLabel = (channel: { service?: string; serviceType?: string }): string =>
  CONNECTION_TYPE_LABELS[`${channel.service}_${channel.serviceType}`] ?? channel.service ?? ""

const SOURCE_STEP_COPY: Record<string, { title: string; subtitle: string }> = {
  url: { title: "Reading website", subtitle: "Scanning pages for brand voice and content" },
  file: { title: "Processing file", subtitle: "Extracting content from your document" },
}

export const getSteps = (sourceType?: string) => {
  const { title, subtitle } = SOURCE_STEP_COPY[sourceType ?? "url"] ?? SOURCE_STEP_COPY.url
  return [
    {
      key: "create_source",
      title,
      subtitle,
      started: "create_source_started" as const,
      done: "create_source_done" as const,
    },
    {
      key: "create_profile",
      title: "Creating profile",
      subtitle: "Generating AI models and content strategies",
      started: "create_profile_started" as const,
      done: "create_profile_done" as const,
    },
  ]
}

export const STEPS = getSteps();

export const STATUS_FLOW = [
    "pending",
    "started",
    "create_source_started",
    "create_source_done",
    "create_profile_started",
    "create_profile_done",
    "define_posts_started",
    "define_posts_done",
    "planAndCreate_posts_started",
    "planAndCreate_posts_done",
    "done",
] as const;

export const HEALTH_FLOW = ["healthy", "failed", "user_acknowledged_failure"] as const;

// Map content factory categories to existing content type IDs used by ContentTypeBadge
export const CATEGORY_TO_CONTENT_TYPE: Record<string, string> = {
  educational: "educational",
  entertaining: "entertain",
  promotional: "promotional",
  workplace: "employees",
  personal: "personal",
}
